<template>
    <div>
        <div class="page__head  container">
            <div class="declarer__head-inner block declarer-header">
                <h1 class="page__title">Заявители</h1>
                <div class="entity-header__btns declarer-top">
                    <a href="#declarer-types" class="object__ctrl-group collapse-link collapsed js-collapse-toggle" data-toggle="collapse" data-scroll-to="">
                        <div class="object__ctrl-btn button button--th-main">
                            Cоздать нового заявителя
                            <span class="testimony-individual__icon">
                                <i class="icon icon--add"></i>
                            </span>
                        </div>
                    </a>
                </div>
                <!-- заявки -->
                <div id="declarer-types" class="object-info accordion-body collapse">
                    <div class="object-info__inner accordion-body__inner">
                        <div class="declare-applications object block">
                            <div class="object__table entity-header">
                                <div class="object__cell">
                                    <a href="/STS/Declarer/AddUL" class="h2 link status-primary">ЮЛ</a>
                                </div>
                            </div>
                            <div class="object__table entity-header">
                                <div class="object__cell">
                                    <a href="/STS/Declarer/AddFL" class="h2 link status-primary">ФЛ</a>
                                </div>
                            </div>
                            <div class="object__table entity-header">
                                <div class="object__cell">
                                    <a href="/STS/Declarer/AddIP" class="h2 link status-primary">ИП</a>
                                </div>
                            </div>
                            <div class="object__table entity-header">
                                <div class="object__cell">
                                    <a href="/STS/Declarer/AddOMSU" class="h2 link status-primary">ОМСУ</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert alert--info text-primary" style="margin: 10px;">
                <p>
                    Для получения доступа к ранее поданным заявкам по вопросам подключения/заключенным договорам о подключении сообщите по адресу <a style="color: darkblue; text-decoration: underline;" href="https://epp@sibgenco.ru/">epp@sibgenco.ru</a> ваши ФИО, логин ЕПП и наименование Заявителя,
                    от имени которого Вы подавали заявки/заключали договоры о подключении. После проверки предоставленных сведений Вам будет настроен доступ к просмотру поданных ранее заявок/заключенных договоров о подключении.
                </p>
            </div>
        </div>
        <div class="page__main container">
            <div class="page__index">
                <div class="declares">
                    <!--<div class="grid__item grid__item--flow">-->
                    <!-- Объявление -->
                    <!--</div>-->

                    <div class="grid__item grid__item--flow">
                        <div class="objects">
                            <div v-if="loading">
                                <div class="main-preloader--first" style="display:block; text-align: center;">
                                    <span class="main-preloader__item main-preloader__item--first"></span>
                                    <span class="main-preloader__item main-preloader__item--second"></span>
                                    <span class="main-preloader__item main-preloader__item--third"></span>
                                </div>
                            </div>
                            <div v-else>
                                <section v-if="errored">
                                    <p>Извините, API не может вернуть данные</p>
                                </section>
                                <div v-else-if="declarers.length === 0" style="margin: 10px">
                                    <h2>Внимание! Для продолжения работы Вам необходимо создать заявителя</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="declares__list js-collapse-toggle-container">


                        <div v-for="item in declarers" class="declares__item">
                            <div class="declare block">
                                <div class="object__table entity-header declarer-header-margin-right">
                                    <div class="object__cell object__cell--small object__cell--center">

                                        <a v-if="item.declarerType == 1 " :href="'/STS/Declarer/AddUL?DeclarerId='+item.id" class="link"><span class="link__icon fab-icon fab-icon--light"><i class="icon icon--setting"></i></span></a>
                                        <a v-if="item.declarerType == 2 " :href="'/STS/Declarer/AddFL?DeclarerId='+item.id" class="link"><span class="link__icon fab-icon fab-icon--light"><i class="icon icon--setting"></i></span></a>
                                        <a v-if="item.declarerType == 3 " :href="'/STS/Declarer/AddIP?DeclarerId='+item.id" class="link"><span class="link__icon fab-icon fab-icon--light"><i class="icon icon--setting"></i></span></a>
                                        <a v-if="item.declarerType == 4 " :href="'/STS/Declarer/AddOMSU?DeclarerId='+item.id" class="link"><span class="link__icon fab-icon fab-icon--light"><i class="icon icon--setting"></i></span></a>
                                    </div>
                                    <div v-if="item.declarerType == 1" class="object__cell object__cell--big">
                                        <div class="object__label object__label--top">Наименование заявителя</div>
                                        <a href="" class="h2 link status-primary">{{item.ulBasicInfo.name}}</a>
                                        <div class="object__label object__label--bottom">
                                            ИНН {{item.ulBasicInfo.inn}}
                                            <br />
                                            <a href="" class="status-primary link" v-if="item.attorneyDetails != null" :style="attorneyValid(item) ? (attorneyMonthValid(item) ? '' : 'color:green;') : 'color: red;' ">
                                                доверенность с {{ item.attorneyDetails.issueDate | formatDate}} по {{ item.attorneyDetails.validityDate | formatDate }}
                                                <div class="help" :style="attorneyMonthValid(item) ? 'display: none;' : ''">
                                                    <div data-toggle="dropdown" class="help__icon fab-icon" :style="attorneyStyle(item)">
                                                        <i class="icon icon--help"></i>
                                                    </div>
                                                    <div class="help__drop">
                                                        <div v-if="!attorneyValid(item)" class="help__inner">
                                                            Внимание! Для подачи заявки необходимо обновить доверенность!
                                                        </div>
                                                        <div v-else class="help__inner">
                                                            Внимание! Заканчивается срок действия доверенности! Обновите документы или прием заявок будет приостановлен!
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>

                                        </div>
                                    </div>
                                    <div v-if="item.declarerType == 2" class="object__cell object__cell--big">
                                        <div class="object__label object__label--top">Наименование заявителя</div>
                                        <a href="" class="h2 link status-primary">{{item.flBasicInfo.fio.lastName}} {{item.flBasicInfo.fio.firstName}} {{item.flBasicInfo.fio.patronymic}}</a>
                                        <div class="object__label object__label--bottom">
                                            СНИЛС {{item.flBasicInfo.snils}}
                                            <br />
                                            <a href="" class="status-primary link" v-if="item.attorneyDetails != null" :style="attorneyValid(item) ? (attorneyMonthValid(item) ? '' : 'color:green;') : 'color: red;' ">
                                                доверенность с {{ item.attorneyDetails.issueDate | formatDate}} по {{ item.attorneyDetails.validityDate | formatDate }}
                                                <div class="help" :style="attorneyMonthValid(item) ? 'display: none;' : ''">
                                                    <div data-toggle="dropdown" class="help__icon fab-icon" :style="attorneyStyle(item)">
                                                        <i class="icon icon--help"></i>
                                                    </div>
                                                    <div class="help__drop">
                                                        <div v-if="!attorneyValid(item)" class="help__inner">
                                                            Внимание! Для подачи заявки необходимо обновить доверенность!
                                                        </div>
                                                        <div v-else class="help__inner">
                                                            Внимание! Заканчивается срок действия доверенности! Обновите документы или прием заявок будет приостановлен!
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div v-if="item.declarerType == 3" class="object__cell object__cell--big">
                                        <div class="object__label object__label--top">Наименование заявителя</div>
                                        <a href="" class="h2 link status-primary">{{item.individualEmployerBasicInfo.fio.lastName}} {{item.individualEmployerBasicInfo.fio.firstName}} {{item.individualEmployerBasicInfo.fio.patronymic}}</a>
                                        <div class="object__label object__label--bottom">
                                            ИНН {{item.individualEmployerBasicInfo.inn}}
                                            <br />
                                            <a href="" class="status-primary link" v-if="item.attorneyDetails != null" :style="attorneyValid(item) ? (attorneyMonthValid(item) ? '' : 'color:green;') : 'color: red;' ">
                                                доверенность с {{ item.attorneyDetails.issueDate | formatDate}} по {{ item.attorneyDetails.validityDate | formatDate }}
                                                <div class="help" :style="attorneyMonthValid(item) ? 'display: none;' : ''">
                                                    <div data-toggle="dropdown" class="help__icon fab-icon" :style="attorneyStyle(item)">
                                                        <i class="icon icon--help"></i>
                                                    </div>
                                                    <div class="help__drop">
                                                        <div v-if="!attorneyValid(item)" class="help__inner">
                                                            Внимание! Для подачи заявки необходимо обновить доверенность!
                                                        </div>
                                                        <div v-else class="help__inner">
                                                            Внимание! Заканчивается срок действия доверенности! Обновите документы или прием заявок будет приостановлен!
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div v-if="item.declarerType == 4" class="object__cell object__cell--big">
                                        <div class="object__label object__label--top">Наименование заявителя</div>
                                        <a href="" class="h2 link status-primary">{{item.municipalBasicInfo.name}}</a>
                                        <div class="object__label object__label--bottom">
                                            ИНН {{item.municipalBasicInfo.inn}}
                                        </div>
                                    </div>
                                    <div class="object__right entity-header__btns declarer-top">
                                        <div class="object__buttons">
                                            <div class="object__ctrl-group button--group-yellow">
                                                <div class="add-drop object__ctrl-link">
                                                    <a href="" :class="'object__ctrl-btn button button--th-main link ' + disableCreatePetitions(item)" data-toggle="dropdown">Подать заявку</a>
                                                    <a data-toggle="dropdown" class="object__ctrl-down link" style="cursor: pointer;">
                                                        &nbsp;
                                                    </a>
                                                    <div class="add-drop__drop declarer-top__drop">
                                                        <div class="add-drop__drop-inner">
                                                            <a v-for="theme in item.petitionTypes" v-bind:href="hrefByIdPetitionType(item.declarerType, theme.id, item.id)" class="link declarer-top__drop-item">
                                                                {{
theme.name
                                                                }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <a v-bind:href="'#declarer-applications_'+item.id" :class="'object__ctrl-group collapse-link collapsed js-collapse-toggle ' + disableCreatePetitions(item)" data-toggle="collapse" data-scroll-to="">
                                                <div class="object__ctrl-btn button button--th-main">Заявки</div>
                                                <div class="object__ctrl-down">
                                                    {{(item.petitions ==null)?0:item.petitions.length}}
                                                </div>
                                                <!--<div class="fab-icon__label fab-icon__label--heighter" v-if="calcNoReadedPetitions(item.petitions)>0">{{calcNoReadedPetitions(item.petitions)}}</div>-->
                                            </a>
                                            <a v-bind:href="'#declarer-contracts_'+item.id" :class="'object__ctrl-group collapsed js-collapse-toggle ' + disableCreatePetitions(item)" data-toggle="collapse" data-scroll-to="">
                                                <div class="object__ctrl-btn button button--th-main"> Договоры <br/>и объекты </div>
                                                <div class="object__ctrl-down">
                                                    {{(item.pacts ==null)?0:item.pacts.length}}
                                                </div>
                                                <!--<div class="fab-icon__label fab-icon__label--heighter">{{(item.pacts ==null)?0:item.pacts.length}}</div>-->
                                            </a>
                                            <a v-bind:href="'/STS/Request/ActsCompare?declarerId='+item.id" :class="'link object__ctrl-group collapsed js-collapse-toggle ' + disableCreatePetitions(item)">
                                                <div class="object__ctrl-btn button button--th-main">Акт сверки</div>
                                                <div class="object__ctrl-down">
                                                    Запросить
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- заявки -->
                            <div v-bind:id="'declarer-applications_'+item.id" class="object-info accordion-body collapse">
                                <div class="object-info__inner accordion-body__inner">
                                    <div v-for="req in item.petitions" class="declare-applications object block">
                                        <div class="object__table entity-header">
                                            <div class="object__cell">
                                                <div class="object__label object__label--top">Заявка</div>
                                                <a href="#" class="h2 link status-primary">{{req.number}}</a>
                                                <div class="object__label object__label--bottom">
                                                    от {{req.registrationDate | formatDate }}
                                                    <!--<a href="#" class="fab-icon__label fab-icon__label--static" v-if="!req.isReaded">1</a>-->
                                                </div>
                                            </div>
                                            <div class="object__cell object__cell--title h5">
                                                <table class="declarer-text-info">
                                                    <tbody>
                                                        <tr class="declarer-text-info__row">
                                                            <td class="declarer-text-info__cell declarer-text-info__label">Тема заявки: </td>
                                                            <td class="declarer-text-info__cell">{{req.petitionType.name}}</td>
                                                        </tr>
                                                        <tr class="declarer-text-info__row" v-if="addressString(req.objectAddress).trim().length > 0">
                                                            <td class="declarer-text-info__cell declarer-text-info__label">Адрес объекта: </td>
                                                            <td class="declarer-text-info__cell">
                                                                {{ addressString(req.objectAddress) }}
                                                            </td>
                                                        </tr>
                                                        <tr class="declarer-text-info__row" v-if="req.objectType.trim().length > 0">
                                                            <td class="declarer-text-info__cell declarer-text-info__label">Наименовение: </td>
                                                            <td class="declarer-text-info__cell">{{req.objectType}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>
                                                <div class="object__description">
                                                    <table class="declarer-text-info">
                                                        <tbody>
                                                            <tr class="declarer-text-info__row">
                                                                <td class="declarer-text-info__cell declarer-text-info__label">Статус: </td>
                                                                <td class="declarer-text-info__cell">
                                                                    <div class="help-container-left">
                                                                        <span>{{req.statusText}} от {{req.lastEditDate | formatDate }}</span>
                                                                        <span class="help">
                                                                            <div class="help__icon fab-icon" data-toggle="dropdown">
                                                                                <i class="icon icon--help"></i>
                                                                            </div>
                                                                            <div class="help__drop help__drop--lg">
                                                                                <div class="help__inner">{{req.statusText}}</div>
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr class="declarer-text-info__row" v-if="req.statusHelpText.trim().length > 0 && req.status === 3">
                                                                <td class="declarer-text-info__cell declarer-text-info__label">Действия: </td>
                                                                <td class="declarer-text-info__cell">{{ req.declineText + '. ' + req.statusHelpText }}</td>
                                                            </tr>
                                                            <tr class="declarer-text-info__row" v-else-if="req.statusHelpText.trim().length > 0 && req.status === 4">
                                                                <td class="declarer-text-info__cell declarer-text-info__label">Действия: </td>
                                                                <td class="declarer-text-info__cell" @click="actionsDeclinePetitions.push(req.id);" v-if="actionsDeclinePetitions.findIndex(i => i === req.id) === -1">{{ req.statusHelpText }}<a style="cursor: pointer;"> (показать подробности)</a></td>
                                                                <td class="declarer-text-info__cell" @click="actionsDeclinePetitions.splice(actionsDeclinePetitions.findIndex(i => i === req.id), 1);" v-else>{{ req.statusHelpText + ': ' + req.declineText }}</td>
                                                            </tr>
                                                            <tr class="declarer-text-info__row" v-else-if="req.statusHelpText.trim().length && req.status !== 9">
                                                                <td class="declarer-text-info__cell declarer-text-info__label">Действия: </td>
                                                                <td class="declarer-text-info__cell">{{ req.statusHelpText }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="object__right entity-header__btns">
                                                    <div class="object__buttons">
                                                        <div class="object__ctrl-group">
                                                            <a href="" :class="'button button--th-main' + isDisabledSendButton(req, item)" @click="SendPetitionButton($event, req.id)">Подписать</a>
                                                        </div>
                                                        <div class="object__ctrl-group" v-if="(disableCreatePetitions(item) === 'is-disable') || (req.status !== 1 && req.status !== 3)">
                                                            <a v-if="req.petitionType.id==7" :href="hrefByIdPetitionTypeAndStatus(item.declarerType, req.petitionType.id, item.id, req.pact.id, req.id, req.reason, req.status, req.lastEditDate, req.declineText)" class="button button--th-main">Просмотреть</a>
                                                            <a v-else :href="hrefByIdPetition(item.declarerType, req.petitionType.id, item.id, req.id, (disableCreatePetitions(item) !== 'is-disable'))" class="button button--th-main">Просмотреть</a>
                                                        </div>
                                                        <div class="object__ctrl-group" v-else>
                                                            <a v-if="req.petitionType.id==7" :href="hrefByIdPetitionTypeAndStatus(item.declarerType, req.petitionType.id, item.id, req.pact.id, req.id, req.reason, req.status, req.lastEditDate, req.declineText)" class="button button--th-main">Просмотреть <br> Изменить</a>
                                                            <a v-else :href="hrefByIdPetition(item.declarerType, req.petitionType.id, item.id, req.id, (disableCreatePetitions(item) !== 'is-disable'))" class="button button--th-main">Просмотреть <br> Изменить</a>
                                                        </div>
                                                        <div class="object__ctrl-group">
                                                            <a href="" :class="'button button--th-second' + isDisabledWithdrawButton(req, item)" @click="WithdrawPetitionButton($event, req.id)">Отозвать</a>
                                                        </div>
                                                        <div class="object__ctrl-group">
                                                            <a href="" :class="'button button--th-error' + isDisabledDeleteButton(req, item)" @click="DeletePetitionButton($event, req.id)">Удалить</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- договоры -->
                            <div v-bind:id="'declarer-contracts_'+item.id" class="object-info accordion-body collapse">
                                <div class="object-info__inner accordion-body__inner">

                                    <div v-for="(pact, index) in item.pacts">

                                        <div class="object declare-contracts block">
                                            <div class="object__table entity-header">
                                                <div class="object__cell">
                                                    <div class="object__label object__label--top">Договор:</div>
                                                    <a href="" class="h2 link status-primary">{{pact.number}}</a>
                                                    <div class="object__label object__label--bottom">от {{pact.date | formatDate }}<a href="" class="fab-icon__label fab-icon__label--static">1</a></div>
                                                </div>
                                                <div class="object__cell object__cell--title h5">
                                                    <table class="declarer-text-info">
                                                        <tbody>
                                                            <tr class="declarer-text-info__row help-container-left">
                                                                <td class="declarer-text-info__cell declarer-text-info__label">Адрес объекта: </td>
                                                                <td class="declarer-text-info__cell">{{pact.objectAddress}}</td>
                                                            </tr>
                                                            <tr class="declarer-text-info__row help-container-left">
                                                                <td class="declarer-text-info__cell declarer-text-info__label">Наименовение: </td>
                                                                <td class="declarer-text-info__cell">{{pact.objectName}}</td>
                                                            </tr>
                                                            <tr class="declarer-text-info__row help-container-left">
                                                                <td class="declarer-text-info__cell declarer-text-info__label">Нагрузка: </td>
                                                                <td class="declarer-text-info__cell"><a href="" class="link status-primary">{{pact.agreedPower}} Гкал/ч</a></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div>
                                                    <div class="object__right entity-header__btns">
                                                        <div class="object__buttons">
                                                            <a v-bind:href="'#road-map_'+ pact.id" class="object__ctrl-group collapsed js-collapse-toggle-second" data-toggle="collapse" data-scroll-to="">
                                                                <div class="object__ctrl-btn button button--th-main">Заявки по <br>&nbsp;договору</div>
                                                                <div class="object__ctrl-down">
                                                                    Показать
                                                                </div>
                                                                <div class="fab-icon__label fab-icon__label--heighter" v-if="countUnreadedPetitionsForPact(pact.roadMap) > 0">{{countUnreadedPetitionsForPact(pact.roadMap)}}</div>
                                                            </a>
                                                            <a v-bind:href="'/STS/Request/ContractChange?declarerId=' + item.id+'&pactId='+pact.id+'&reasonId=3'" class="object__ctrl-group collapsed js-collapse-toggle-second" data-scroll-to="">
                                                                <div class="object__ctrl-btn button button--th-main">Срок ввода <br> {{pact.connectionDate | formatDate }}</div>
                                                                <div class="object__ctrl-down">
                                                                    Перенести
                                                                </div>
                                                            </a>
                                                            <a href="" class="object__ctrl-group collapsed js-collapse-toggle-second" data-toggle="collapse" data-scroll-to="">
                                                                <div class="object__ctrl-btn button button--th-main">{{ pact.payDate != null ? 'Оплатить' : 'Оплачено' }} <br>{{pact.payAmount | formatAmount }}</div>
                                                                <div class="object__ctrl-down status-error" v-if="dateToJsDate(pact.payDate)<nowDate">
                                                                    {{ pact.payDate != null ? 'до' : ' &nbsp;' }} {{pact.payDate | formatDate }}
                                                                </div>
                                                                <div v-else class="object__ctrl-down status-success">
                                                                    {{ pact.payDate != null ? 'до' : ' &nbsp;' }} {{pact.payDate | formatDate }}
                                                                </div>
                                                            </a>
                                                            <a v-bind:href="'#payment_'+ pact.id" data-toggle="collapse" class="object__ctrl-group collapsed js-collapse-toggle-second" data-scroll-to="">
                                                                <div class="object__ctrl-btn button button--th-main">График оплат <br>на {{ nowDate | formatDateToStr }}</div>
                                                                <div class="object__ctrl-down">
                                                                    Показать
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="objects__info block declarer__info-block">
                                            <div class="account-info declarer__info-inner">
                                                <div class="account-info__item declarer__info-item">
                                                    <div class="declarer__info-label">Строительство/реконструкция тепловой сети:</div>
                                                    <div class="account-info__value"><span v-if="!pact.lastMile">не</span>&nbsp;требуется</div>
                                                </div>
                                                <!--<div class="account-info__item declarer__info-item">
                                                    <div class="declarer__info-label">Способ реализации:</div>
                                                    <div class="account-info__value">{{pact.implemenationWay}}</div>
                                                </div>-->
                                            </div>
                                        </div>


                                        <!-- дорожная карта -->
                                        <div v-bind:id="'road-map_'+ pact.id" class="road-map accordion-body collapse">
                                            <div class="accordion-body__inner">
                                                <div class="road-map__header object-info__section block">
                                                    <div class="road-map__title h2 title-normal-weight">
                                                        Дорожная карта подключения по договору <br>{{pact.number}} от {{pact.date | formatDate }}
                                                    </div>
                                                    <div class="road-map__numbers">
                                                        <div class="request-way js-request-way">
                                                            <div v-bind:class="'request-way__item ' + classStatusSteproadMap(step.number, pact.roadMap)" v-for="step in pact.roadMap.steps">
                                                                <div class="request-way__icon fab-icon">
                                                                    <div v-show="noticeForStepRoadMap(step.number, pact.roadMap) == true" class="request-way__label fab-icon">
                                                                        <i class="icon icon--info"></i>
                                                                    </div>
                                                                    <div class="request-way__count h3">{{step.number}}</div>
                                                                </div>
                                                                <div class="request-way__title">{{step.name}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="road-map__inner object-info__section object-info__section--sm block">
                                                    <div class="request-table road-map__table">
                                                        <div class="request-table__row request-table__row--head h5">
                                                            <div class="road-map__cell road-map__cell--xs">Этап</div>
                                                            <div class="road-map__cell road-map__cell--s">Дата заявки</div>
                                                            <div class="road-map__cell road-map__cell--s">Номер заявки</div>
                                                            <div class="road-map__cell">Тема заявки</div>
                                                            <div class="road-map__cell">Дата обновления</div>
                                                            <div class="road-map__cell">Статус заявки</div>
                                                            <div class="road-map__cell road-map__cell--l">Действия</div>
                                                            <div class="road-map__cell">Подробнее</div>
                                                        </div>


                                                        <div v-bind:class="'request-table__row road-map__row h5 '/* + classStatusSteproadMap(petition.stepNumber, pact.roadMap)*/" v-for="petition in pact.roadMap.petitions">
                                                            <div class="road-map__cell road-map__cell--light road-map__cell--xs">
                                                                <div class="request-table__label">Этап</div>
                                                                {{petition.stepNumber === -1 ? '-' : petition.stepNumber}}
                                                            </div>
                                                            <div class="road-map__cell road-map__cell--light road-map__cell--s">
                                                                <div class="request-table__label">Дата заявки</div>
                                                                {{petition.petition.registrationDate  | formatDate }}
                                                            </div>
                                                            <div class="road-map__cell road-map__cell--s">
                                                                <div class="request-table__label">Номер заявки</div>
                                                                <!--<a href="" class="link status-primary">100100</a>-->
                                                                {{petition.petition.number == 0 ? '-' : petition.petition.number}}
                                                            </div>
                                                            <div class="road-map__cell">
                                                                <div class="request-table__label">Тип заявки</div>
                                                                {{petition.petition.petitionType.name}}
                                                                <div v-if="petition.petition.isReaded == false" class="request-table__label fab-icon">
                                                                    <i class="icon icon--info"></i>
                                                                </div>
                                                            </div>
                                                            <div class="road-map__cell">
                                                                <div class="request-table__label">Дата обновления</div>
                                                                {{petition.petition.lastEditDate  | formatDate }}
                                                            </div>
                                                            <div class="road-map__cell">
                                                                <div class="request-table__label">Статус заявки</div>
                                                                {{petition.petition.statusText}}
                                                            </div>
                                                            <div class="road-map__cell road-map__cell--l">
                                                                <div class="request-table__label">Комментарий</div>
                                                                {{petition.petition.statusHelpText}}
                                                            </div>
                                                            <div class="road-map__cell">
                                                                <div class="request-table__label">Доступные действия</div>
                                                                <div class="road-map__actions">
                                                                    <div class="road-map__actions-item">
                                                                        <a v-bind:href="hrefByIdPetitionType(item.declarerType, petition.petition.petitionType.id, item.id) + '&petitionId=' + petition.petition.id" :class="'declare__ctrl button-icon button-icon--th-ctrl button--blue-hover' + (petition.petition.id === 0 ? ' is-disable' : '')">
                                                                            <i class="icon icon--arrow-right">
                                                                            </i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- график оплат -->
                                        <div v-bind:id="'payment_'+ pact.id" class="object-info accordion-body collapse">
                                            <PaymentChart :pact="pact" :key="pact.pactId"></PaymentChart>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    Vue.config.devtools = true;

    import Vue from 'vue'
    import Vuelidate from 'vuelidate'

    import DeclarerInfo from './DeclarerInfo.vue'
    import OfflineServiceAvailableAd from '../../../../Components/Accounts/OfflineServiceAvailableAd.vue'

	import PaymentChart from './PaymentChart.vue'

    Vue.use(Vuelidate);

    Vue.filter('RUB', function (value) {
        if (value === null || isNaN(value))
            return '0';
        return Number(value).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' });
    });

    export default {
        components: {
            DeclarerInfo,
            OfflineServiceAvailableAd,
            PaymentChart
        },

        data() {
            return {
                openedAccountStatus: 'Opened',
                closedAccountStatus: 'Closed',
                info: null,
                declarers: [],
                requests: [],
                pacts: [],
                tuList: [],
                tuGroup: [],
                loading: true,
                errored: false,
                filterText: '',
                signCountToStartFilter: 4,
                nowDate: new Date(),
                actionsDeclinePetitions: [],
            };
        },
        computed: {

            filteredTuGroup: function () {
                if (this.filterText.length < this.signCountToStartFilter)
                    return this.tuGroup;

                var filterResult = this.filterByAddress();

                return Object.keys(filterResult).length > 0 ? filterResult : this.filterByAccountAndDeviceNumbers();
            }
        },
        mounted() {
            axios
                .get('/STS/Declarer/DeclarerLink')
                .then(response => {
                    this.info = response.data;
                    this.loadDeclarers('/STS/Declarer/Declarers');
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true;
                })

        },
        filters: {
            f4(value) {
                return value;//.toFixed(4);
            },
            ruF2(number) {
                if (number === null) return 0;
                return number.toLocaleString('ru-RU');
            },
            formatDate(value) {
                if (value) {
                    return value.substring(8, 10) + "." + value.substring(5, 7) + "." + value.substring(0, 4);
                }
            },
            formatTarif(value) {
                var digitsValue = parseFloat(value);
                if (digitsValue) {
                    if (digitsValue == 0) {
                        return '-'
                    }
                    else { 
                        return digitsValue.toFixed(2);
                    }
                }
                else return '-';
            },

            formatDateToStr: function (dateValue) {
                //format date
                return moment(dateValue).format('DD.MM.YYYY');
            },

            formatAmount: function (value) {
                if (value) {
                    //var formatCalc = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
                    //               return formatCalc;
                    // return Number(value).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' });
                    return Number(value).toLocaleString('ru-RU', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
                else {
                    return "";
                }
            }
        },

        methods: {
            addressString: function (address) {
                if (address == null) return '';
                let area = address.area;
                let locality = address.locality;
                let city = address.city;
                let street = address.street;
                let house = address.house;

                if (locality.lastIndexOf(' п') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' п'));
                    if (locality.length > 0) locality = 'п. ' + locality;
                };
                if (locality.lastIndexOf(' д') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' д'));
                    if (locality.length > 0) locality = 'д. ' + locality;
                };
                if (locality.lastIndexOf(' с/с') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' с/с'));
                    if (locality.length > 0) locality = 'с/с ' + locality;
                };
                if (locality.lastIndexOf(' с') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' с'));
                    if (locality.length > 0) locality = 'с. ' + locality;
                };
                if (locality.lastIndexOf(' у') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' у'));
                    if (locality.length > 0) locality = 'у. ' + locality;
                };
                if (locality.lastIndexOf(' х') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' х'));
                    if (locality.length > 0) locality = 'х. ' + locality;
                };
                if (locality.lastIndexOf(' ст') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' ст'));
                    if (locality.length > 0) locality = 'ст. ' + locality;
                };
                if (locality.lastIndexOf(' автодорога') > 0) {
                    locality = locality.substring(0, locality.lastIndexOf(' автодорога'));
                    if (locality.length > 0) locality = 'автодорога ' + locality;
                };

                if (city.lastIndexOf(' г') > 0) city = 'г. ' + city.substring(0, city.lastIndexOf(' г'));
                if (street.lastIndexOf(' ул') > 0) street = 'ул. ' + street.substring(0, street.lastIndexOf(' ул'));
                if (house.lastIndexOf(' д') > 0) house = 'д. ' + house.substring(0, house.lastIndexOf(' д'));

                let resString = '';

                if (area.length > 0) {
                    resString = area;
                    if (locality.length > 0 || street.length > 0 || house.length > 0) resString += ', ';
                    if (locality.length > 0) {
                        resString += locality;
                        if (street.length > 0 || house.length > 0) resString += ', ';
                    };
                } else {
                    if (city.length > 0) {
                        resString = city;
                        if (street.length > 0 || house.length > 0) resString += ', ';
                    };
                }
                if (street.length > 0) {
                    resString += street;
                    if (house.length > 0) resString += ', ';
                };
                if (house.length > 0) resString += house;
                return resString;
            },
            hrefByIdPetition: function (DeclarerType, PetitionType, Id, PetitionId, AllowEdit) {
                var href = "";
                switch (PetitionType) {
                    case 1:
                        href = "/STS/Request/AddTU?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                        break;
                    case 2:
                        href = "/STS/Request/Other?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                        break;
                    case 3:
                        href = "/STS/Request/GPZU?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                        break;
                    case 4:
                        switch (DeclarerType) {
                            case 1:
                                href = "/STS/Request/ConnectionUL?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                                break;
                            case 2:
                                href = "/STS/Request/ConnectionFL?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                                break
                            case 3:
                                href = "/STS/Request/ConnectionIP?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                                break;
                            case 4:
                                href = "/STS/Request/ConnectionOMS?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                                break;
                        };
                        break;
                    case 6:
                        href = "/STS/Request/AgrProject?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                        break;
                    case 7:
                        href = "/STS/Request/ContractChange?declarerId=" + Id + '&PetitionId=' + PetitionId;
                        break;
                    case 10:
                        href = "/STS/Request/ACT?declarerId=" + Id + '&PetitionId=' + PetitionId;
                        break;
                    case 27:
                        href = "/STS/Request/ActsCompare?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                        break;
                    case 29:
                        href = "/STS/Request/TUPRequest?declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                        break;
                    default:
                        href = "/STS/Request/Template?petitionTypeId=" + PetitionType + "&declarerId=" + Id + '&PetitionId=' + PetitionId + '&AllowEdit=' + AllowEdit;
                        break;
                }
                return href;
            },
            hrefByIdPetitionType: function (DeclarerType, PetitionType, Id) {
                var href = "";
                switch (PetitionType) {
                    case 1:
                        href = "/STS/Request/AddTU?declarerId=" + Id;
                        break;
                    case 2:
                        href = "/STS/Request/Other?declarerId=" + Id;
                        break;
                    case 3:
                        href = "/STS/Request/GPZU?declarerId=" + Id;
                        break;
                    case 4:
                        switch (DeclarerType) {
                            case 1:
                                href = "/STS/Request/ConnectionUL?declarerId=" + Id;
                                break;
                            case 2:
                                href = "/STS/Request/ConnectionFL?declarerId=" + Id;
                                break
                            case 3:
                                href = "/STS/Request/ConnectionIP?declarerId=" + Id;
                                break;
                            case 4:
                                href = "/STS/Request/ConnectionOMS?declarerId=" + Id;
                                break;
                        };
                        break;
                    case 6:
                        href = "/STS/Request/AgrProject?declarerId=" + Id;
                        break;
                    case 7:
                        href = "/STS/Request/ContractChange?declarerId=" + Id;
                        break;
                    case 10:
                        href = "/STS/Request/ACT?declarerId=" + Id;
                        break;
                    case 27:
                        href = "/STS/Request/ActsCompare?declarerId=" + Id;
                        break;
                    case 29:
                        href = "/STS/Request/TUPRequest?declarerId=" + Id;
                        break;
                    default:
                        href = "/STS/Request/Template?petitionTypeId=" + PetitionType + "&declarerId=" + Id;
                        break;
                }
                return href;
            },
            isDisabledSendButton: function (req, item) {
                if ((this.disableCreatePetitions(item) === 'is-disable') || req.id < 0)
                    return ' is-disable';
                return (req.status === 1 || req.status === 3) && req.valid === true ? '' : ' is-disable';
            },
            isDisabledWithdrawButton: function (req, item) {
                if ((this.disableCreatePetitions(item) === 'is-disable') || req.id < 0)
                    return ' is-disable';
                return req.status === 2 || req.status === 3 ? '' : ' is-disable';
            },
            isDisabledDeleteButton: function (req, item) {
                if ((this.disableCreatePetitions(item) === 'is-disable') || req.id < 0)
                    return ' is-disable';
                return req.status === 1 || req.status === 4 || req.status === 9 ? '' : ' is-disable';
            },
            DeletePetitionButton: function (event, petitionID) {
                event.preventDefault();

                var a = event.target;
                if (a.innerHTML === 'Удалить') {
                    a.insertAdjacentHTML('afterbegin', 'Да, ');
                    return;
                }

                event.target.classList.add("is-disable", "is-overlay");

                var formData = new FormData();
                formData.append("petitionId", petitionID);

                axios
                    .post('/STS/Request/DeletePetition', formData)
                    .then(function (response) {
                        if (response.data.validationErrors !== null) {
                            console.log('Axios Error: ' + response.validationErrors.message);
                            alert("Произошла ошибка удаления! Попробуйте снова или обратитесь в поддержку.");
                        }
                        else if (!response.data.success)//или какая то другая ошибка
                        {
                            console.log('Axios Error: ' + response.error.message);
                            alert("Произошла ошибка удаления! Попробуйте снова или обратитесь в поддержку.");
                        }
                    })
                    .catch(function (error) {
                        event.target.classList.remove("is-disable");
                        if (error.response) {
                            console.log('Axios Error data: ' + error.response.data);
                            console.log('Axios Error status: ' + error.response.status);
                        } else if (error.request) {
                            console.log('Axios Error request: ' + error.request);
                        } else {
                            console.log('Axios Error message: ' + error.message);
                        }
                        console.log('Axios Error config : ' + error.config);
                        alert("Произошла ошибка удаления! Попробуйте снова или обратитесь в поддержку.");
                    })
                    .then(function () {
                        event.target.classList.remove("is-overlay");
                        document.location.href = "/STS/Declarer/Index";
                    });
            },
    //Отменить заявку
            WithdrawPetitionButton: function (event, petitionID) {
                event.preventDefault();

                var a = event.target;
                if (a.innerHTML === 'Отозвать') {
                    a.insertAdjacentHTML('afterbegin', 'Да, ');
                    a.style.backgroundColor = '#ed412d';
                    return;
                };

                event.target.classList.add("is-disable", "is-overlay");

                var formData = new FormData();
                formData.append("petitionId", petitionID);

                axios
                    .post('/STS/Request/WithdrawPetition', formData)
                    .then(function (response) {
                        //// возможно валидация на сервере прошла не успешно
                        if (response.data.validationErrors !== null) {
                            console.log('Axios Error: ' + response.validationErrors.message);
                            alert("Произошла ошибка отзыва заявки! Попробуйте снова или обратитесь в поддержку.");
                        }
                        else if (!response.data.success)//или какая то другая ошибка
                        {
                            console.log('Axios Error: ' + response.error.message);
                            alert("Произошла ошибка отзыва заявки! Попробуйте снова или обратитесь в поддержку.");
                        }
                    })
                    .catch(function (error) {
                        event.target.classList.remove("is-disable");
                        if (error.response) {
                            console.log('Axios Error data: ' + error.response.data);
                            console.log('Axios Error status: ' + error.response.status);
                        } else if (error.request) {
                            console.log('Axios Error request: ' + error.request);
                        } else {
                            console.log('Axios Error message: ' + error.message);
                        }
                        console.log('Axios Error config : ' + error.config);
                        alert("Произошла ошибка отправления! Попробуйте снова или обратитесь в поддержку.");
                    })
                    .then(function () {
                        event.target.classList.remove("is-overlay");
                        document.location.href = "/STS/Declarer/Index";
                    });
            },

			// Подписать и отправить
			SendPetitionButton: function (event, petitionID) {
				event.preventDefault();
				event.target.classList.add("is-disable", "is-overlay");

				var formData = new FormData();
				formData.append("petitionId", petitionID);

				axios
					.post('/STS/Request/SendPetition', formData)
					.then(function (response) {
						if (response.data.validationErrors !== null) {
							console.log('Axios Error: ' + response.validationErrors.message);
							alert("Произошла ошибка отзыва заявки! Попробуйте снова или обратитесь в поддержку.");
						}
						else if (!response.data.success)//или какая то другая ошибка
						{
							console.log('Axios Error: ' + response.error.message);
							alert("Произошла ошибка отзыва заявки! Попробуйте снова или обратитесь в поддержку.");
						}
					})
					.catch(function (error) {
						event.target.classList.remove("is-disable");
						if (error.response) {
							console.log('Axios Error data: ' + error.response.data);
							console.log('Axios Error status: ' + error.response.status);
						} else if (error.request) {
							console.log('Axios Error request: ' + error.request);
						} else {
							console.log('Axios Error message: ' + error.message);
						}
						console.log('Axios Error config : ' + error.config);
						alert("Произошла ошибка отправления! Попробуйте снова или обратитесь в поддержку.");
					})
					.then(function () {
						event.target.classList.remove("is-overlay");
						document.location.href = "/STS/Declarer/Index";
					});
			},

			hrefByIdPetitionTypeAndStatus: function (DeclarerType, PetitionType, Id, pactId, petitionId, reason, status, lastEditDate, declineText) {
				var href = "";
				console.log(PetitionType);
				switch (PetitionType) {
					case 1:
						href = "/STS/Request/AddTU?declarerId=" + Id; 
						break;
					case 2:
						href = "/STS/Request/Other?declarerId=" + Id;
						break;
					case 3:
						href = "/STS/Request/GPZU?declarerId=" + Id;
						break;
					case 4:
						switch (DeclarerType) {
							case 1:
								href = "/STS/Request/ConnectionUL?declarerId=" + Id;
								break;
							case 2:
								href = "/STS/Request/ConnectionFL?declarerId=" + Id;
								break
							case 3:
								href = "/STS/Request/ConnectionIP?declarerId=" + Id;
								break;
						};
						break;
					case 5:
						href = "/STS/Request/Template?petitionTypeId=" + PetitionType + "&declarerId=" + Id;
						break;
					case 6:
						href = "/STS/Request/Template?petitionTypeId=" + PetitionType + "&declarerId=" + Id;
						break;
                    case 7:
						href = "/STS/Request/ContractChange?declarerId=" + Id + '&pactId=' + pactId + '&petitionId=' + petitionId + '&reasonId=' + reason + '&petitionStatus=' + status + '&lastEditDate=' + lastEditDate + '&declineText=' + declineText;
						break;
					case 8:
						href = "/STS/Request/Template?petitionTypeId=" + PetitionType + "&declarerId=" + Id;
						break;
					case 9:
						href = "/STS/Request/Template?petitionTypeId=" + PetitionType + "&declarerId=" + Id;
						break;
					case 10:
						href = "/STS/Request/ACT?declarerId=" + Id;
						break;
				}
				return href;
			},

            formatStrToDate: function (strValue) {
                if (strValue === undefined || strValue === null || strValue.length === 0)
                    return new Date();
				var year = Number(strValue.split(".")[2]);
				var month = Number(strValue.split(".")[1]) - 1;
				var day = Number(strValue.split(".")[0]);
				return new Date(year, month, day);
            },

            formatDate(value) {
                if (value) {
                    return value.substring(8, 10) + "." + value.substring(5, 7) + "." + value.substring(0, 4);
                }
            },

            disableCreatePetitions(kontAgent) {
                if (kontAgent.municipalBasicInfo != null)
                    return "";

                if (kontAgent.IsOwner)
                    return "";

                if (kontAgent.authorizedRepresentative != null)
                    if (!this.attorneyValid(kontAgent))
                        return "is-disable";
                return "";
            },

            attorneyValid(kontAgent) {
                if (kontAgent.attorneyDetails == null) return false;

                var validDate = this.formatDate(kontAgent.attorneyDetails.validityDate);
                if (validDate !== undefined) {
                    var datValidParts = validDate.split('.');
                    var validDateJS = new Date(datValidParts[2] + '-' + datValidParts[1] + '-' + datValidParts[0]);
                    if (validDateJS < new Date()) {
                        return false;
                    };
                } else {
                    return false;
                }
                return true;
            },

            attorneyMonthValid(kontAgent) {
                if (kontAgent.attorneyDetails == null) return false;

                var validDate = this.formatDate(kontAgent.attorneyDetails.validityDate);
                if (validDate !== undefined) {
                    var datValidParts = validDate.split('.');
                    var validDateJS = new Date(datValidParts[2] + '-' + datValidParts[1] + '-' + datValidParts[0]);
                    validDateJS.setMonth(validDateJS.getMonth() - 1);
                    if (validDateJS < new Date()) {
                        return false;
                    };
                }
                else {
                    return false;
                }

                return true;
            },

            attorneyStyle(kontAgent) {
                if (kontAgent.attorneyDetails == null) return false;

                var validDate = this.formatDate(kontAgent.attorneyDetails.validityDate);
                if (validDate !== undefined) {
                    var datValidParts = validDate.split('.');
                    var validDateJS = new Date(datValidParts[2] + '-' + datValidParts[1] + '-' + datValidParts[0]);
                    var attDateJS = new Date(datValidParts[2] + '-' + datValidParts[1] + '-' + datValidParts[0]);
                    attDateJS.setMonth(attDateJS.getMonth() - 1);
                    if (validDateJS < new Date()) {
                        return 'color: white; background: red;';
                    } else if (attDateJS < new Date())
                    {
                        return 'color: white; background: #0078a8;';
                    }
                } else {
                    return 'color: white; background: red;';
                }
                return '';
            },

            dateToJsDate: function (date) {
                var jsDate = new Date();
                if (date) {
                    var strDate = this.formatDate(date);
                    if (strDate) {
                        jsDate = this.formatStrToDate(strDate);
                    }
                    return jsDate;
                }

            },

            calcNoReadedPetitions: function (petitions) {
                var calc = 0;
                if (petitions !== null) {
                    for (var petition in petitions) {
                        var readed = petitions[petition].isReaded;
                        if (readed == false) calc = calc + 1;
                    }
                }
                return calc;
            },
            noticeForStepRoadMap: function (step, roadMap) {
                var notice = false;
                for (var i = 0; i < roadMap.petitions.length; i++) {
                    if (roadMap.petitions[i].stepNumber == step && notice != true) {
                        notice = !roadMap.petitions[i].petition.isReaded;
                    }
                };
                return notice;
            },
            countUnreadedPetitionsForPact: function (roadMap) {
                var count = 0;
                for (var i = 0; i < roadMap.petitions.length; i++) {
                    if (roadMap.petitions[i].petition.isReaded == false)
                        count++;
                };
                return count;
            },
            classStatusSteproadMap: function (step, roadMap) {
                var stepStatusInt = 0;
                for (var i = 0; i < roadMap.steps.length; i++) {
                    if (roadMap.steps[i].number == step) {
                        stepStatusInt = roadMap.steps[i].stepStatus;
                    }
                }
                var stepStatusString = "";
                switch (stepStatusInt) {
                    case 0:
                        stepStatusString = "not-active";
                        break;
                    case 1:
                        stepStatusString = "is-active";
                        break;
                    case 2:
                        stepStatusString = "is-done";
                        break;
                    default:
                        stepStatusString = "";
                }
                return stepStatusString;
            },

            loadDeclarers: function (link) {
                var self = this;

                axios
                    .get(link)
                    .then(response => {
                        this.declarers = response.data;
                    })
                    .catch(error => {
                        console.log('load declarer error: ' + error);
                        this.errored = true;
                    })
                    .finally(() => (this.loading = false));
            },

            groupBy: function (array, key) {
                const result = {}
                array.forEach(item => {
                    if (!result[item[key]]) {
                        result[item[key]] = []
                    }
                    result[item[key]].push(item)
                });
                return result
            },

            clearFilter: function () {
                this.filterText = '';
            },
            filterByAddress: function () {
                var self = this;
                var filteredAddresses = [];

                Object.keys(self.tuGroup).forEach(key => {
                    if (key.toLowerCase().includes(self.filterText.toLowerCase()))
                        filteredAddresses.indexOf(key) === -1 && filteredAddresses.push(key);
                });

                return self.filterTuGroup(filteredAddresses);
            },
            filterByAccountAndDeviceNumbers: function () {
                var self = this;
                var filteredAddresses = [];

                Object.keys(self.tuGroup).forEach(key => {
                    self.tuGroup[key].forEach(device => {
                        if (device.AccountNumber == self.filterText || device.SerialNumber == self.filterText) {
                            filteredAddresses.indexOf(key) === -1 && filteredAddresses.push(key);
                        }
                    })
                });

                return self.filterTuGroup(filteredAddresses);
            },
            filterTuGroup: function (allowedAddresses) {
                return allowedAddresses
                    .reduce((obj, key) => {
                        obj[key] = this.tuGroup[key];
                        return obj;
                    }, {});
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/app/sts/declarers/declarer/Declarer.vue